
            const data = {"name":"caret-rounded","data":{"width":"11","height":"7","viewBox":"0 0 11 7","data":"<path pid=\"0\" d=\"m1 5.5 4.051-4.05 4.05 4.05\" _stroke=\"#853585\" stroke-width=\"2\" stroke-linecap=\"round\"/>","originalColors":[{"type":"stroke","color":"#853585"}],"stopColors":[]}}
        
                    module.exports = data
                    